"use strict";exports.__esModule=true;exports.default=getProductFilters;var _core=require("@lingui/core");function getProductFilters(){return{aggregations:{tastings:{title:/*i18n*/{id:'Tastings'},conjunction:false,get:function get(product){var _product$inLeeds,_product$inLeeds2,_product$inLeeds3;if(!((_product$inLeeds=product.inLeeds)!==null&&_product$inLeeds!==void 0&&_product$inLeeds.text))return undefined;if(((_product$inLeeds2=product.inLeeds)===null||_product$inLeeds2===void 0?void 0:_product$inLeeds2.text)==='No, this wine is only in London')return'London tasting';return"Leeds - "+((_product$inLeeds3=product.inLeeds)===null||_product$inLeeds3===void 0?void 0:_product$inLeeds3.text);},size:20,sort:'term'},newFor2023:{title:/*i18n*/{id:'New for 2023'},conjunction:false,get:function get(product){var _product$thisIsANewPr;return(_product$thisIsANewPr=product.thisIsANewProductForTheUkIn2021)!==null&&_product$thisIsANewPr!==void 0&&_product$thisIsANewPr.value?'New for 2023':undefined;},size:20},denomination:{title:/*i18n*/{id:'D.O.'},conjunction:false,multiSelect:false,size:100,sort:'term',get:function get(product){return product.denomination||undefined;}// Excludes nulls
},primaryGrapeVariety:{title:/*i18n*/{id:'Primary grape varieties'},conjunction:false,size:300,get:function get(product){var _product$grapeVarieti;var varieties=product===null||product===void 0?void 0:(_product$grapeVarieti=product.grapeVarieties)===null||_product$grapeVarieti===void 0?void 0:_product$grapeVarieti.map(function(_ref){var varietyName=_ref.varietyName;return varietyName;}).filter(Boolean);if(!(varieties!==null&&varieties!==void 0&&varieties.length))return[];return varieties[0];}},highlights:{title:/*i18n*/{id:'Highlights'},conjunction:false,get:function get(product){var _product$highlights,_product$highlights$v;var highlights=((_product$highlights=product.highlights)===null||_product$highlights===void 0?void 0:(_product$highlights$v=_product$highlights.values)===null||_product$highlights$v===void 0?void 0:_product$highlights$v.map(function(highlight){return highlight||'';}))||[];return highlights.filter(function(highlight){return highlight!=='None';});},size:20},productType:{title:/*i18n*/{id:'Product types'},conjunction:false,get:function get(product){return product.wineType||// product.spiritType ||
// product.beerType ||
product.productType;},size:20,translations:{WINE:/*i18n*/{id:'Other wine'},SPIRIT:/*i18n*/{id:'Spirit'},Stillwein:/*i18n*/{id:'Wine'},// BEER: defineMessage({ message: 'Beer and more' }),
// This is only for Switzerland
BEER:"Lebensmittel"}},availableInUKRetail:{title:/*i18n*/{id:'Available in UK Retail'},conjunction:false,get:function get(product){var _product$currentlyAva;return(_product$currentlyAva=product.currentlyAvailableInUkRetail)!==null&&_product$currentlyAva!==void 0&&_product$currentlyAva.value?'Available in UK Retail':undefined;},size:20},customerSegments:{title:/*i18n*/{id:'Customer segments'},conjunction:false,get:function get(product){var _product$customerSegm,_product$customerSegm2;var customerSegments=((_product$customerSegm=product.customerSegments)===null||_product$customerSegm===void 0?void 0:(_product$customerSegm2=_product$customerSegm.values)===null||_product$customerSegm2===void 0?void 0:_product$customerSegm2.map(function(segment){return segment||'';}))||[];return[...customerSegments].filter(Boolean);},size:20},// regionHierarchy: {
//   title: defineMessage({ message: 'Winegrowing regions' }),
//   conjunction: false,
//   // multiSelect: false,
//   size: 100,
//   get: (product) => product.regionHierarchy?.map((e) => e || '') || [], // Excludes nulls
// },
// allGrapeVarieties: {
//   title: defineMessage({ message: 'All grape varieties' }),
//   conjunction: true,
//   multiSelect: true,
//   size: 300,
//   get: (product) => {
//     const varieties = product?.grapeVarieties
//       ?.map(({ varietyName }) => varietyName)
//       .filter(Boolean);
//     if (!varieties?.length) return [];
//     if (varieties.length === 1) return ['Single variety', ...varieties];
//     if (varieties.length > 1) return ['Blend', ...varieties];
//     return varieties;
//   },
//   translations: {
//     Blend: defineMessage({ message: 'Blend' }),
//     'Single variety': defineMessage({ message: 'Single variety' }),
//   },
// },
vintage:{title:/*i18n*/{id:'Vintages'},conjunction:false,size:50,sort:'term',order:'desc',get:function get(product){return product.vintage||undefined;},// Excludes nulls
translations:{NV:/*i18n*/{id:'NV'}}}// priceRanges: {
//   title: defineMessage({ message: 'Price ranges' }),
//   conjunction: false,
//   sort: 'term',
//   // This comes from ProductsTemplate.afterQuery.
//   get: (product: Product) => product.pricing?.priceRange || undefined, // Excludes nulls
// },
// productionMethods: {
//   title: defineMessage({ message: 'Production methods' }),
//   conjunction: false,
//   size: 20,
//   get: (product) =>
//     product?.characteristics
//       ?.filter((value) =>
//         [
//           'VEGAN',
//           'ORGANIC',
//           'VEGETARIAN',
//           'BIODYNAMIC',
//           'KOSHER',
//           'SUSTAINABLE',
//         ].includes(value || '')
//       )
//       .map((e) => e || '') || [],
//   translations: {
//     VEGAN: defineMessage({ message: 'vegan' }),
//     ORGANIC: defineMessage({ message: 'organic' }),
//     VEGETARIAN: defineMessage({ message: 'vegetarian' }),
//     BIODYNAMIC: defineMessage({ message: 'biodynamic' }),
//     KOSHER: defineMessage({ message: 'kosher' }),
//     SUSTAINABLE: defineMessage({ message: 'sustainable' }),
//   },
// },
// classification: {
//   title: defineMessage({ message: 'Classifications' }),
//   conjunction: false,
//   size: 50,
//   get: (product) => {
//     if (!product?.classification) return undefined; // Excludes nulls
//     if (product.classification === '----') return undefined;
//     if (product.classification === 'No classification') return undefined;
//     return product.classification;
//   },
// },
// specialClassification: {
//   title: defineMessage({ message: 'Special classifications' }),
//   conjunction: false,
//   size: 50,
//   get: (product) => {
//     if (!product?.specialClassification) return undefined; // Excludes nulls
//     if (product.specialClassification === '----') return undefined;
//     return product.specialClassification;
//   },
// },
// designation: {
//   title: defineMessage({ message: 'Designations' }),
//   conjunction: false,
//   size: 50,
//   get: (product) => product.designation || undefined, // Excludes nulls
// },
// closureTypes: {
//   title: defineMessage({ message: 'Closure types' }),
//   conjunction: false,
//   size: 50,
//   get: (product) => product.bottleVariants?.[0]?.closureType || undefined, // Excludes nulls
// },
},sortings:{// byProducerName: {
//   title: defineMessage({ message: 'Producer name' }),
//   field: [
//     (product) => product?.producer?.sortName || product?.producer?.name,
//   ],
//   order: 'asc',
//   group: 'producer.producerId',
//   groupHeader: 'producer',
// },
byProductName:{title:/*i18n*/{id:'Product name'},field:['shortName','vintage'],order:['asc','desc']}// byExhibitorName: {
//   title: defineMessage({ message: 'Exhibitor name' }),
//   field: [
//     'exhibitor.sortName',
//     'exhibitor.name',
//     'producer.sortName',
//     'producer.name',
//   ],
//   order: 'asc',
//   group: 'exhibitorId',
// },
// byStandNumber: {
//   title: defineMessage({ message: 'Table number' }),
//   field: [
//     sortBy.standName,
//     'exhibitor.sortName',
//     'exhibitor.name',
//     'producer.sortName',
//     'producer.name',
//   ],
//   order: 'asc',
//   group: 'registration.registrationId',
// },
}};}// Sort helper functions
var sortBy={standName:function standName(product){var _product$stand;return(product===null||product===void 0?void 0:(_product$stand=product.stand)===null||_product$stand===void 0?void 0:_product$stand.name.split(/[\s,-]+/).map(function(segment){return segment==='Tisch'?undefined:Number(segment)?segment.padStart(3,'0'):segment;}).filter(Boolean).join(' '))||'999';}};var fragment="1260874335";